import logging from '@wr/logging';
import {fetchProvider} from '../../utils/fetchProvider';
import eventIds from '../../event-ids';
import config from '../../config';

const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);

export async function getTransferData(paymentSessionId) {
    try {
        logger.info('Manual bank transfer getData started', {
            paymentSessionId
        });
        const url = new URL(`/api/confirmation/details/${paymentSessionId}`, config.manualBankTransfer.url);

        const transferData = await fetchProvider(url.href);
        logger.info('Retrieved Manual bank transfer getData', {
            paymentSessionId
        });

        return transferData;
    } catch (error) {
        logger.error(`Error retrieving Manual bank transfer props: ${error.message}`, {
            error,
            eventId: eventIds['Error retrieving Manual bank transfer data']

        });
        throw error;
    }
}
